import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppContext } from 'src/app/services/app-context.service';

export interface DealItem {
  id: string;
  title: string;
  desc: string;
  // fromPrice: string;
  imageUrl: string;
  href: string;
  type: string;
  referenceId: string;
}

@Component({
  selector: 'travel-ui-deal',
  templateUrl: './deal.component.html',
  styleUrls: ['./deal.component.scss']
})
export class DealComponent {
  @Input() item?: DealItem;
  siteName: string | undefined;

  @Output()
  dealSelected: EventEmitter<any> = new EventEmitter();

  constructor(public appContext: AppContext) {
    setTimeout(()=>{
      const str=JSON.parse(sessionStorage.getItem("SiteContext") || '{}');
      this.siteName = str.name;
    }, 1000)

  }

  onDealSelected() {

    this.dealSelected.emit(this.item);
  }
}
